import { render } from "./AmazonPayButton.vue?vue&type=template&id=6df2ab83"
import script from "./AmazonPayButton.vue?vue&type=script&lang=js"
export * from "./AmazonPayButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__